const LoadingSpinner = () => {
  return <div>Loading....</div>;
};

export default LoadingSpinner;
